<template>
  <router-view/>
</template>

<style>
@import 'assets/css/app.css';
</style>
  